import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleLogin = async () => {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/auth/login`,
      {
        method: "POST",
        //headers brauchen wir sodass das Backend weiß, dass wir JSON-Daten senden
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      },
    );
    const data = await response.json();
    console.log(data);
    if (data.success) {
      localStorage.setItem("token", data.token);
      console.log(data.token);
      //Token dekodieren
      /*
      .split(".") – teilt den Token in diese 3 Teile auf
      [1] – nimmt den mittleren Teil (payload) wo deine Daten drin sind
      atob() – dekodiert Base64 zurück zu normalem Text
      JSON.parse() – wandelt den Text in ein JavaScript Objekt um

      Danach hast du Zugriff auf alles was du in den JWT gepackt hast,
      also user_id, company_id, und subdomain
      */
      const payLoad = JSON.parse(atob(data.token.split(".")[1]));
      localStorage.setItem("subdomain", payLoad.subdomain);
      navigate("/dashboard");
    }
    console.log(data);
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#0a0a0f",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "'DM Sans', sans-serif",
        color: "#f0f0f0",
      }}
    >
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Syne:wght@700;800&family=DM+Sans:wght@300;400;500&display=swap');
        .login-input {
          width: 100%;
          background: rgba(255,255,255,0.04);
          border: 1px solid rgba(255,255,255,0.07);
          border-radius: 10px;
          padding: 12px 16px;
          color: #f0f0f0;
          font-family: 'DM Sans', sans-serif;
          font-size: 0.9rem;
          outline: none;
          transition: border-color 0.2s;
          box-sizing: border-box;
        }
        .login-input:focus { border-color: rgba(200,241,53,0.4); }
        .login-input::placeholder { color: #3a3a4a; }
        .login-label {
          display: block;
          font-size: 0.75rem;
          font-weight: 600;
          color: #6b6b7a;
          letter-spacing: 0.05em;
          text-transform: uppercase;
          margin-bottom: 8px;
        }
        .btn-login {
          width: 100%;
          background: #c8f135;
          color: #0a0a0f;
          border: none;
          border-radius: 10px;
          padding: 13px;
          font-family: 'DM Sans', sans-serif;
          font-size: 0.95rem;
          font-weight: 700;
          cursor: pointer;
          transition: opacity 0.2s;
        }
        .btn-login:hover { opacity: 0.88; }
      `}</style>

      <div
        style={{
          background: "#14141e",
          border: "1px solid rgba(255,255,255,0.07)",
          borderRadius: "20px",
          padding: "48px",
          width: "100%",
          maxWidth: "420px",
        }}
      >
        <h1
          style={{
            fontFamily: "'Syne', sans-serif",
            fontSize: "1.8rem",
            fontWeight: 800,
            letterSpacing: "-0.03em",
            margin: "0 0 8px 0",
          }}
        >
          Willkommen <span style={{ color: "#c8f135" }}>zurück</span>
        </h1>
        <p
          style={{ color: "#6b6b7a", margin: "0 0 36px 0", fontSize: "0.9rem" }}
        >
          Melde dich in deinem Account an
        </p>

        <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
          <div>
            <label className="login-label">Email</label>
            <input
              type="email"
              placeholder="name@firma.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="login-input"
            />
          </div>

          <div>
            <label className="login-label">Passwort</label>
            <input
              type="password"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="login-input"
            />
          </div>

          <button onClick={handleLogin} className="btn-login">
            Einloggen
          </button>
        </div>
      </div>
    </div>
  );
}
